"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getQuestionLabelById = exports.parseQuestionToVersion2 = exports.getAutoOptionsPerRow = exports.getAnnotationEmoji = exports.getAnnotationColor = exports.getAnnotationColorByButton = exports.processVideoAnnotationEmoji = exports.removeTempAnnotations = exports.getUniqueAnnotations = exports.orderByOverlap = exports.zoomKonvaStage = exports.handleKonvaTouch = exports.handleKonvaTouchEnd = exports.isKonvaTouchEnabled = exports.getKonvaStageCenter = exports.getKonvaStageDistance = exports.getBuiltInOptions = exports.parseCoordinatesToOriginal = exports.parseCoordinatesFromOriginal = exports.formatBoxes = exports.getImageRatio = exports.isTrue = exports.findLastIndex = exports.shuffle = exports.fixedShuffleIndex = exports.last = exports.sleep = exports.delay = exports.getQueryStringValue = exports.getLangIdFromCode = void 0;
var _ = require("lodash");
var constants_1 = require("../constants");
var TextService_1 = require("../services/TextService");
var types_1 = require("../types");
var getLangIdFromCode = function (langCode) {
    return (0, exports.last)(langCode.split('/'));
};
exports.getLangIdFromCode = getLangIdFromCode;
/*
 * URL Query parsing funcs and misc helpers
 */
// This is used to extract trackerID (MID), source etc. from URL
// Note: this function is case insensitive, and will return an empty string
// if there is no match.
var getQueryStringValue = function (key) {
    return (decodeURIComponent(window.location.search.replace(new RegExp('^(?:.*[&\\?]' +
        encodeURIComponent(key).replace(/[\.\+\*]/g, '\\$&') +
        '(?:\\=([^&]*))?)?.*$', 'i'), '$1')) || null);
};
exports.getQueryStringValue = getQueryStringValue;
/**
 * Delaying functions -- why do we have two..?
 * Fix.
 */
var delay = function (time) {
    return new Promise(function (resolve, reject) {
        return setTimeout(function () {
            resolve();
        }, time);
    });
};
exports.delay = delay;
var sleep = function (ms) {
    return new Promise(function (resolve) { return setTimeout(resolve, ms); });
};
exports.sleep = sleep;
/*
 * Some useful tools for functional array processing.
 */
// return last member of an array (without modification)
var last = function (arr) {
    return arr[arr.length - 1];
};
exports.last = last;
// shuffles all elements in any array `arr`
// EXCEPT for elements who's index is true in `mask`
// adapted from https://codereview.stackexchange.com/a/196629
var fixedShuffleIndex = function (arr, mask) {
    var w = _.shuffle(arr.reduce(function (acc, e, i) {
        if (!mask[i]) {
            acc.push(e);
        }
        return acc;
    }, []));
    return mask.reduce(function (acc, e, i) {
        if (e) {
            acc.splice(i, 0, arr[i]);
        }
        return acc;
    }, w);
};
exports.fixedShuffleIndex = fixedShuffleIndex;
/*
 * Similar to lodash's shuffle function, but allows deterministic shuffle.
 * Adapted from https://stackoverflow.com/a/55480964
 */
var shuffle = function (array, deterministic) {
    if (deterministic === void 0) { deterministic = false; }
    var xor = function (seed) {
        var _a, _b;
        var baseSeeds = [123456789, 362436069, 521288629, 88675123];
        var x = baseSeeds[0], y = baseSeeds[1], z = baseSeeds[2], w = baseSeeds[3];
        var random = function () {
            var _a;
            var t = x ^ (x << 11);
            _a = [y, z, w], x = _a[0], y = _a[1], z = _a[2];
            w = w ^ (w >> 19) ^ (t ^ (t >> 8));
            return w / 0x7fffffff;
        };
        _a = baseSeeds.map(function (i) { return i + seed; }), x = _a[0], y = _a[1], z = _a[2], w = _a[3];
        _b = [0, 0, 0, 0].map(function () { return Math.round(random() * 1e16); }), x = _b[0], y = _b[1], z = _b[2], w = _b[3];
        return random;
    };
    var m = array.length;
    var t;
    var i;
    var random = deterministic ? xor(1) : xor(Math.random());
    while (m) {
        i = Math.floor(random() * m--);
        t = array[m];
        array[m] = array[i];
        array[i] = t;
    }
    return array;
};
exports.shuffle = shuffle;
/**
 * Returns the index of the last element in the array where predicate is true, and -1
 * otherwise.
 * @param array The source array to search in
 * @param predicate find calls predicate once for each element of the array, in descending
 * order, until it finds one where predicate returns true. If such an element is found,
 * findLastIndex immediately returns that element index. Otherwise, findLastIndex returns -1.
 * Code adapted from https://stackoverflow.com/a/53187807
 */
var findLastIndex = function (array, predicate) {
    var l = array.length;
    while (l--) {
        if (predicate(array[l], l, array))
            return l;
    }
    return -1;
};
exports.findLastIndex = findLastIndex;
/**
 * Validate string 'true' and boolean true, and return boolean type
 * Mainly determine query param ?KEY=true / ?KEY=false
 */
var isTrue = function (value) {
    if (typeof value === 'string') {
        return value.toLowerCase() === 'true';
    }
    return value;
};
exports.isTrue = isTrue;
var getImageRatio = function (image, fixedWitdh) {
    var resizedImage = image;
    var imageratio = image.height / image.width;
    var renderRatio = 1;
    renderRatio = fixedWitdh / resizedImage.width;
    resizedImage.width = fixedWitdh;
    resizedImage.height = fixedWitdh * imageratio;
    return { image: resizedImage, ratio: renderRatio };
};
exports.getImageRatio = getImageRatio;
var formatBoxes = function (boxes, ratio) {
    var formattedBoxes = boxes.map(function (box, i) {
        return __assign(__assign({}, box.coordinates), { id: box.id || null, text: box.label, key: { i: i }, boxID: box.value, stroke: '#f68685', strokeWidth: 1 });
    });
    return (0, exports.parseCoordinatesFromOriginal)(formattedBoxes, ratio);
};
exports.formatBoxes = formatBoxes;
var parseCoordinatesFromOriginal = function (boxes, ratio) {
    var formattedBoxes = boxes.map(function (box, i) {
        if (box.scaled) {
            return box;
        }
        else {
            return __assign(__assign({}, box), { x: box.x * ratio, y: box.y * ratio, width: box.width * ratio, height: box.height * ratio });
        }
    });
    return formattedBoxes;
};
exports.parseCoordinatesFromOriginal = parseCoordinatesFromOriginal;
var parseCoordinatesToOriginal = function (boxes, ratio) {
    var formattedBoxes = boxes.map(function (box, i) {
        var coordinates = box.coordinates;
        return __assign(__assign({}, box), { coordinates: {
                rotation: coordinates.rotation,
                x: coordinates.x / ratio,
                y: coordinates.y / ratio,
                width: coordinates.width / ratio,
                height: coordinates.height / ratio
            } });
    });
    return formattedBoxes;
};
exports.parseCoordinatesToOriginal = parseCoordinatesToOriginal;
var getBuiltInOptions = function (languages, optionSettings, t, translateKey, i18n, questionId) {
    return optionSettings.map(function (optionSetting, index) {
        var value = optionSetting.value || (index + 1).toString();
        var texts = languages === null || languages === void 0 ? void 0 : languages.map(function (language) {
            var _a;
            var text = optionSetting.label;
            if (t && translateKey && i18n) {
                var key = (0, TextService_1.getTranslation)(t, translateKey, {
                    lng: language.value
                }, translateKey);
                if (key !== translateKey) {
                    var wordings = JSON.parse(key);
                    var optionWording = ((_a = wordings === null || wordings === void 0 ? void 0 : wordings.options) === null || _a === void 0 ? void 0 : _a.find(function (opt) { return opt.value == value; })) || { text: text };
                    text = optionWording === null || optionWording === void 0 ? void 0 : optionWording.text;
                }
            }
            return {
                language: language.value,
                contents: [{ type: types_1.MULTIMEDIA_TYPES.TEXT, text: text }]
            };
        });
        return {
            id: constants_1.BUILTIN_OPTION_ID,
            value: value,
            optionKey: questionId ? "".concat(questionId, "_").concat(value) : value,
            label: optionSetting.label,
            texts: texts,
            mediaURL: optionSetting.mediaURL,
            pictureURL: optionSetting.mediaURL
        };
    });
};
exports.getBuiltInOptions = getBuiltInOptions;
var getKonvaStageDistance = function (p1, p2) {
    return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
};
exports.getKonvaStageDistance = getKonvaStageDistance;
var getKonvaStageCenter = function (p1, p2) {
    return {
        x: (p1.x + p2.x) / 2,
        y: (p1.y + p2.y) / 2
    };
};
exports.getKonvaStageCenter = getKonvaStageCenter;
var isKonvaTouchEnabled = function () {
    return ('ontouchstart' in window || navigator.maxTouchPoints > 0
    // || navigator.msMaxTouchPoints > 0
    );
};
exports.isKonvaTouchEnabled = isKonvaTouchEnabled;
function handleKonvaTouchEnd(e, lastCenter, lastDist) {
    lastCenter = null;
    lastDist = 0;
}
exports.handleKonvaTouchEnd = handleKonvaTouchEnd;
function handleKonvaTouch(e, stageRef, lastCenter, lastDist) {
    e.evt.preventDefault();
    var touch1 = e.evt.touches[0];
    var touch2 = e.evt.touches[1];
    var stage = stageRef;
    if (stage !== null) {
        if (touch1 && touch2) {
            if (stage.isDragging()) {
                stage.stopDrag();
            }
            var p1 = {
                x: touch1.clientX,
                y: touch1.clientY
            };
            var p2 = {
                x: touch2.clientX,
                y: touch2.clientY
            };
            if (!lastCenter) {
                lastCenter = (0, exports.getKonvaStageCenter)(p1, p2);
                return;
            }
            var newCenter = (0, exports.getKonvaStageCenter)(p1, p2);
            var dist = (0, exports.getKonvaStageDistance)(p1, p2);
            if (!lastDist) {
                lastDist = dist;
            }
            // local coordinates of center point
            var pointTo = {
                x: (newCenter.x - stage.x()) / stage.scaleX(),
                y: (newCenter.y - stage.y()) / stage.scaleX()
            };
            var scale = stage.scaleX() * (dist / lastDist);
            stage.scaleX(scale);
            stage.scaleY(scale);
            // calculate new position of the stage
            var dx = newCenter.x - lastCenter.x;
            var dy = newCenter.y - lastCenter.y;
            var newPos = {
                x: newCenter.x - pointTo.x * scale + dx,
                y: newCenter.y - pointTo.y * scale + dy
            };
            stage.position(newPos);
            stage.batchDraw();
            lastCenter = newCenter;
            lastDist = dist;
        }
    }
}
exports.handleKonvaTouch = handleKonvaTouch;
var scaleBy = 1.05;
var zoomKonvaStage = function (event, zoomDirection, stageRef) {
    if (event && event.evt) {
        event.evt.preventDefault();
    }
    else if (event) {
        event.preventDefault();
    }
    if (stageRef && stageRef !== null) {
        var stage = stageRef;
        var oldScale = stage.scaleX();
        var pointerX = void 0;
        var pointerY = void 0;
        var newScale = void 0;
        if (zoomDirection) {
            pointerX = stage.width() / 2;
            pointerY = stage.height() / 2;
            newScale =
                zoomDirection === 'zoom-out'
                    ? oldScale / scaleBy
                    : oldScale * scaleBy;
        }
        else {
            var _a = stage.getPointerPosition(), px = _a.x, py = _a.y;
            pointerX = px;
            pointerY = py;
            newScale =
                event.evt.deltaY > 0 ? oldScale / scaleBy : oldScale * scaleBy;
        }
        var pointTo = {
            x: (pointerX - stage.x()) / oldScale,
            y: (pointerY - stage.y()) / oldScale
        };
        stage.scale({ x: newScale, y: newScale });
        var newPos = {
            x: pointerX - pointTo.x * newScale,
            y: pointerY - pointTo.y * newScale
        };
        stage.position(newPos);
        stage.batchDraw();
    }
};
exports.zoomKonvaStage = zoomKonvaStage;
/**
 * Function to reorder boxes/rectangles on Konva based on if it is overlapped.
 */
var orderByOverlap = function (rectangles) {
    // checks to see if top left corner is within another box area
    // that way overlapped boxes are stacked from top left to bottom right
    var numTimesOverlapped = function (rect) {
        return rectangles.filter(function (r) {
            return rect.x > r.x &&
                rect.x < r.x + r.width &&
                rect.y > r.y &&
                rect.y < r.y + r.height;
        }).length;
    };
    var orderedRect = rectangles.sort(function (a, b) { return numTimesOverlapped(a) - numTimesOverlapped(b); });
    return orderedRect;
};
exports.orderByOverlap = orderByOverlap;
var getUniqueAnnotations = function (options) {
    var uniqueAnnotations = _.uniqBy(options.reduce(function (agg, option) {
        if ((option === null || option === void 0 ? void 0 : option.annotations) && Array.isArray(option.annotations)) {
            agg = __spreadArray(__spreadArray([], agg, true), option.annotations, true);
        }
        return agg;
    }, []), 'annotationId');
    return uniqueAnnotations;
};
exports.getUniqueAnnotations = getUniqueAnnotations;
var removeTempAnnotations = function (wordOption) {
    var _a;
    return __assign(__assign({}, wordOption), { annotations: (_a = wordOption === null || wordOption === void 0 ? void 0 : wordOption.annotations) === null || _a === void 0 ? void 0 : _a.filter(function (annotation) { return annotation.annotationId !== 'temp'; }) });
};
exports.removeTempAnnotations = removeTempAnnotations;
var processVideoAnnotationEmoji = function (emoji) {
    if (typeof emoji === 'string') {
        // backwards compatibility for previous video annotation data
        switch (emoji) {
            case 'like':
                return constants_1.ANNOTATION_BUTTONS[0];
            case 'confused':
                return constants_1.ANNOTATION_BUTTONS[1];
            case 'dislike':
                return constants_1.ANNOTATION_BUTTONS[2];
            default:
                break;
        }
    }
    else {
        return emoji;
    }
};
exports.processVideoAnnotationEmoji = processVideoAnnotationEmoji;
var getAnnotationColorByButton = function (button, isBot) {
    if (isBot === void 0) { isBot = false; }
    if ((button === null || button === void 0 ? void 0 : button.color) && (button === null || button === void 0 ? void 0 : button.vizColor)) {
        return isBot ? button.color : button.vizColor;
    }
    return (0, exports.getAnnotationColor)(button.value, isBot);
};
exports.getAnnotationColorByButton = getAnnotationColorByButton;
var getAnnotationColor = function (value, isBot) {
    if (isBot === void 0) { isBot = false; }
    switch (value) {
        case constants_1.ANNOTATION_BUTTONS[0].value:
            return isBot ? constants_1.COLOR_THEME.green : constants_1.COLOR_THEME.blue;
        case constants_1.ANNOTATION_BUTTONS[1].value:
            return constants_1.COLOR_THEME.yellow;
        case constants_1.ANNOTATION_BUTTONS[2].value:
            return constants_1.COLOR_THEME.pink;
        default:
            return constants_1.COLOR_THEME.gray;
    }
};
exports.getAnnotationColor = getAnnotationColor;
var getAnnotationEmoji = function (mediaURL, value) {
    if (mediaURL)
        return mediaURL;
    if (value <= constants_1.ANNOTATION_BUTTONS.length) {
        return constants_1.ANNOTATION_BUTTONS[value - 1].mediaURL;
    }
};
exports.getAnnotationEmoji = getAnnotationEmoji;
var getAutoOptionsPerRow = function (optionSize, type, isMobile) {
    if (isMobile) {
        switch (optionSize) {
            case types_1.OPTION_SIZE.ICON:
                switch (type) {
                    case types_1.OPTION_TYPES.TEXT_ONLY:
                        return 6;
                    case types_1.OPTION_TYPES.IMAGE_ONLY:
                    case types_1.OPTION_TYPES.IMAGE_AND_TEXT:
                        return 6;
                    default:
                        return 6;
                }
            case types_1.OPTION_SIZE.SMALL:
                switch (type) {
                    case types_1.OPTION_TYPES.TEXT_ONLY:
                        return 2;
                    case types_1.OPTION_TYPES.IMAGE_ONLY:
                    case types_1.OPTION_TYPES.IMAGE_AND_TEXT:
                        return 3;
                    default:
                        return 3;
                }
            case types_1.OPTION_SIZE.LARGE:
                switch (type) {
                    case types_1.OPTION_TYPES.TEXT_ONLY:
                        return 2;
                    case types_1.OPTION_TYPES.IMAGE_ONLY:
                    case types_1.OPTION_TYPES.IMAGE_AND_TEXT:
                        return 2;
                    default:
                        return 2;
                }
            case types_1.OPTION_SIZE.MEDIUM:
            default:
                switch (type) {
                    case types_1.OPTION_TYPES.TEXT_ONLY:
                        return 2;
                    case types_1.OPTION_TYPES.IMAGE_ONLY:
                    case types_1.OPTION_TYPES.IMAGE_AND_TEXT:
                        return 2;
                    default:
                        return 2;
                }
        }
    }
    else {
        switch (optionSize) {
            case types_1.OPTION_SIZE.ICON:
                switch (type) {
                    case types_1.OPTION_TYPES.TEXT_ONLY:
                        return 12;
                    case types_1.OPTION_TYPES.IMAGE_ONLY:
                    case types_1.OPTION_TYPES.IMAGE_AND_TEXT:
                        return 12;
                    default:
                        return 12;
                }
            case types_1.OPTION_SIZE.SMALL:
                switch (type) {
                    case types_1.OPTION_TYPES.TEXT_ONLY:
                        return 3;
                    case types_1.OPTION_TYPES.IMAGE_ONLY:
                    case types_1.OPTION_TYPES.IMAGE_AND_TEXT:
                        return 6;
                    default:
                        return 6;
                }
            case types_1.OPTION_SIZE.LARGE:
                switch (type) {
                    case types_1.OPTION_TYPES.TEXT_ONLY:
                        return 3;
                    case types_1.OPTION_TYPES.IMAGE_ONLY:
                    case types_1.OPTION_TYPES.IMAGE_AND_TEXT:
                        return 3;
                    default:
                        return 3;
                }
            case types_1.OPTION_SIZE.MEDIUM:
            default:
                switch (type) {
                    case types_1.OPTION_TYPES.TEXT_ONLY:
                        return 3;
                    case types_1.OPTION_TYPES.IMAGE_ONLY:
                    case types_1.OPTION_TYPES.IMAGE_AND_TEXT:
                        return 4;
                    default:
                        return 4;
                }
        }
    }
};
exports.getAutoOptionsPerRow = getAutoOptionsPerRow;
/**
 *  @BACKWARD_COMPATIBILITY
 * For release v2.0 to support New option UI
 * Get rid of TextTranslation and support MultimediaTexts
 */
function parseQuestionToVersion2(q) {
    var _a, _b, _c, _d, _e;
    try {
        var questionTexts = (0, TextService_1.parseTextTranslationToMultimediaText)(q.questionTexts);
        var texts = (0, TextService_1.parseTextTranslationToMultimediaText)(q.texts);
        var options = ((q === null || q === void 0 ? void 0 : q.options) || []).map(function (opt) { return (__assign(__assign({}, opt), { texts: (0, TextService_1.parseTextTranslationToMultimediaText)(opt === null || opt === void 0 ? void 0 : opt.texts), altTexts: (0, TextService_1.parseTextTranslationToMultimediaText)(opt === null || opt === void 0 ? void 0 : opt.altTexts) })); });
        var buttons = ((q === null || q === void 0 ? void 0 : q.buttons) || []).map(function (opt) { return (__assign(__assign({}, opt), { texts: (0, TextService_1.parseTextTranslationToMultimediaText)(opt === null || opt === void 0 ? void 0 : opt.texts), altTexts: (0, TextService_1.parseTextTranslationToMultimediaText)(opt === null || opt === void 0 ? void 0 : opt.altTexts) })); });
        return __assign(__assign({}, q), { texts: texts, questionTexts: questionTexts, alternateWordingTexts: (0, TextService_1.parseTextTranslationToMultimediaText)(q.alternateWordingTexts), followUpTexts: (0, TextService_1.parseTextTranslationToMultimediaText)(q.followUpTexts), followUpTextsLike: (0, TextService_1.parseTextTranslationToMultimediaText)(q.followUpTextsLike), followUpTextsDislike: (0, TextService_1.parseTextTranslationToMultimediaText)(q.followUpTextsDislike), followUpTextsConfused: (0, TextService_1.parseTextTranslationToMultimediaText)(q.followUpTextsConfused), continueTexts: (0, TextService_1.parseTextTranslationToMultimediaText)(q.continueTexts), notApplicableTexts: (0, TextService_1.parseTextTranslationToMultimediaText)(q.notApplicableTexts), options: options, buttons: buttons, optionSettings: __assign(__assign({}, q.optionSettings), { numColumns: typeof ((_a = q.optionSettings) === null || _a === void 0 ? void 0 : _a.numColumns) === 'number'
                    ? (_b = q.optionSettings) === null || _b === void 0 ? void 0 : _b.numColumns
                    : q.optionsLayout !== 1
                        ? q.optionsLayout
                        : 0, numColumnsMobile: typeof ((_c = q.optionSettings) === null || _c === void 0 ? void 0 : _c.numColumnsMobile) === 'number'
                    ? (_d = q.optionSettings) === null || _d === void 0 ? void 0 : _d.numColumnsMobile
                    : 0, size: ((_e = q.optionSettings) === null || _e === void 0 ? void 0 : _e.size) || types_1.OPTION_SIZE.AUTO }) });
    }
    catch (err) {
        return q;
    }
}
exports.parseQuestionToVersion2 = parseQuestionToVersion2;
function getQuestionLabelById(questions, questionId) {
    var _a;
    if (questionId > 0 && (questions === null || questions === void 0 ? void 0 : questions.length) > 0) {
        return (_a = questions.find(function (q) { return q.id == questionId; })) === null || _a === void 0 ? void 0 : _a.title;
    }
    else {
        switch (questionId) {
            case types_1.SPECIAL_QIDS.DEVICE:
                return constants_1.DEVICE_TYPE_VALUE;
            case types_1.SPECIAL_QIDS.LANGUAGE:
                return constants_1.LANGUAGE_VALUE;
            case types_1.SPECIAL_QIDS.PANEL_SOURCE:
                return 'SampleSource';
        }
    }
    return '';
}
exports.getQuestionLabelById = getQuestionLabelById;
//# sourceMappingURL=question.js.map